import { render, staticRenderFns } from "./namespace_token.vue?vue&type=template&id=335d5604"
import script from "./namespace_token.vue?vue&type=script&lang=js"
export * from "./namespace_token.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports